/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { actionMatcher, getValue, InitState, NgxsPlugin, setValue, UpdateState } from '@ngxs/store';
import { Inject, Injectable, InjectionToken, Injector } from '@angular/core';
import { LoggerService } from '../../modules/shared/services/logger.service';
import { NgxsResetPluginOptions } from './ngxs-reset.model';

export const NGXS_RESET_PLUGIN_OPTIONS = new InjectionToken('NGXS_RESET_PLUGIN_OPTIONS');

@Injectable()
export class NgxsResetPlugin implements NgxsPlugin {
    private defaultState = {};

    constructor(
        private logger: LoggerService,
        private injector: Injector,
        @Inject(NGXS_RESET_PLUGIN_OPTIONS) private readonly options: NgxsResetPluginOptions
    ) {
        if (!this.options.trigger) {
            throw new Error("Option 'trigger' is required.");
        }
    }

    public handle(state, action, next) {
        const matches = actionMatcher(action);
        const isInitAction = matches(InitState);
        const isUpdateAction = matches(UpdateState);
        const isTriggerAction = matches(this.options.trigger);

        if (isInitAction) {
            this.defaultState = state;
        }
        if (isUpdateAction) {
            this.defaultState = { ...(action as UpdateState).addedStates, ...this.defaultState };
        }

        if (isTriggerAction) {
            let resetState = { ...this.defaultState };
            if (this.options.preserve && this.options.preserve.length > 0) {
                for (let i = 0; i < this.options.preserve.length; i++) {
                    const current = getValue(state, this.options.preserve[i]);
                    resetState = setValue(resetState, this.options.preserve[i], current);
                }
                state = resetState;
            }
        }
        return next(state, action);
    }
}
